module.exports = __webpack_public_path__ + "img/stena28.054459a3.jpg";